import { useEffect, useRef, useState } from "react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

const Step3CompleteRegistrationForm = ({
  onBack,
  formData,
  setFormData,
  completeRegistration,
  onLoginSuccess
}) => {
  const [userType, setUserType] = useState(formData?.userType || "buyer-owner");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const nameInputRef = useRef();
  const emailInputRef = useRef();
  const reraInputRef = useRef();

  const handleInputChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    nameInputRef.current?.focus();
  }, []);

  const handleSubmit = async () => {
    if (!formData.name || !formData.email) {
      alert("Please fill in required fields");
      return;
    }

    const payload = {
      phone: formData.phoneNumber,
      name: formData.name,
      email: formData.email,
      city: formData.city,
      role: userType,
      reraId: formData?.reraNumber,
    };

    try {
      setIsSubmitting(true);
      await completeRegistration(payload);
      onLoginSuccess();
    } catch (err) {
      console.error("Registration failed:", err);
      alert("Something went wrong");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="w-full bg-white rounded-2xl shadow-xl overflow-hidden flex flex-col p-4 sm:p-8 relative">
      {/* Back button */}
      {/* <button
        onClick={onBack}
        className="self-start absolute top-10 right-10 flex items-center gap-1.5 px-3 py-1.5 rounded-md border border-transparent text-gray-700 font-medium select-none
          hover:text-btn-brandRed hover:bg-btn-brandRed/10 hover:border-btn-brandRed
          active:scale-95 transition-all duration-200 hover:shadow-sm"
      >
        <FiArrowLeft className="text-base transition-transform duration-200" />
        <span className="text-xs">Back</span>
      </button> */}
      {/* Heading */}
      <div className="mb-4">
        <h2 className="text-[1.4rem] sm:text-2xl font-semibold text-gray-900 mb-3">
          You are a...
        </h2>
        <div className="flex flex-wrap gap-3">
          {[
            { label: "Buyer / Owner", value: "buyer-owner" },
            { label: "Agent / Builder", value: "agent-builder" },
          ].map((type) => (
            <button
              key={type.value}
              onClick={() => setUserType(type.value)}
              className={`px-4 py-1.5 rounded-full font-medium text-sm transition-all ${
                userType === type.value
                  ? "bg-cyan-500 text-white border border-cyan-500"
                  : "bg-white text-gray-600 border border-gray-300 hover:border-cyan-500"
              }`}
            >
              {type.label}
            </button>
          ))}
        </div>
      </div>

      {/* Input fields */}
      <div className="space-y-4 mb-5">
        {/* Name */}
        <div>
          <label className="block ml-1 text-sm font-semibold text-gray-800 mb-1.5">
            Name<span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            ref={nameInputRef}
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                emailInputRef.current?.focus();
              }
            }}
            required
            placeholder="Your Name"
            className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-1 focus:ring-btn-brandRed transition-all duration-200 placeholder-gray-400"
          />
        </div>

        {/* Email */}
        <div>
          <label className="block ml-1 text-sm font-semibold text-gray-800 mb-1.5">
            Enter Email ID <span className="text-red-500">*</span>
          </label>
          <input
            type="email"
            ref={emailInputRef}
            name="email"
            value={formData.email}
            required
            onChange={handleInputChange}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                if (userType === "agent-builder") {
                  reraInputRef.current?.focus();
                } else {
                  handleSubmit();
                }
              }
            }}
            placeholder="Email Address"
            className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-1 focus:ring-btn-brandRed transition-all duration-200 placeholder-gray-400"
          />
        </div>

        {/* Additional fields for agent-builder */}
        {/* {userType === "agent-builder" && (
          <>
            <div>
              <label className="block ml-1 text-sm font-semibold text-gray-800 mb-1.5">
                RERA Number{" "}
                <span className="text-gray-500 text-xs font-normal">
                  (Optional)
                </span>
              </label>
              <input
                type="text"
                name="reraNumber"
                ref={reraInputRef}
                value={formData.reraNumber}
                onChange={handleInputChange}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleSubmit();
                  }
                }}
                placeholder="RERA Number"
                className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-1 focus:ring-btn-brandRed transition-all duration-200 placeholder-gray-400"
              />
            </div>
          </>
        )} */}
      </div>

      {/* Submit button with spinner */}
      <button
        type="button"
        onClick={handleSubmit}
        disabled={isSubmitting}
        className="w-full bg-btn-brandRed hover:bg-btn-brandRedHover text-white font-semibold text-base py-3.5 rounded-full transition-all transform hover:scale-[1.02] active:scale-[0.98] shadow-lg flex justify-center items-center gap-2"
      >
        {isSubmitting && (
          <AiOutlineLoading3Quarters className="animate-spin text-lg" />
        )}
        {isSubmitting ? "Completing..." : "Complete Registration"}
      </button>
    </div>
  );
};

export default Step3CompleteRegistrationForm;
